export default class Sound {
  static async play(path, isMuted = false) {
    const audio = new Audio(path)
    audio.muted = isMuted
    audio.play()
  }
}
